import { FormattedMessage } from 'react-intl';
import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';
import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';

import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';
import WixSDK from 'shared/utils/wix-sdk';
import { notForPreview } from 'widget/utils/not-for-preview';
import { isSignInVisible } from 'shared/utils/layout-helpers';

import { getAllSettings } from 'shared/selectors/app-settings';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';

import { sides } from 'shared/constants/popout';
import { sideShape } from 'shared/shapes/popout';

import { LinkButton } from 'shared/components/button/button';
import Tooltip from 'shared/components/tooltip/tooltip';
import { hideTooltip } from 'shared/components/tooltip/tooltip-popout';
import ChannelSubscription from 'widget/components/payments/channel-subscription';

import styles from './account-button.styl';

import translations from './translations';

export class BaseAccountButton extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    onSubscribeClick: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    onUserLogin: React.PropTypes.func,
    onUserLogout: React.PropTypes.func,
    channelData: React.PropTypes.object,
    className: React.PropTypes.string,
    popoutSide: sideShape,
    currentSiteUser: React.PropTypes.object,
    biEvent: React.PropTypes.func,
  };

  static defaultProps = {
    popoutSide: sides.BOTTOM,
    onSubscribeClick: _.noop,
    onSubscriptionCancelClick: _.noop,
    onUserLogin: _.noop,
    onUserLogout: _.noop,
  };

  @autobind
  @notForPreview
  showLoginForm() {
    const { biEvent, onUserLogin } = this.props;

    biEvent('widget.signIn.clicked');
    WixSDK.requestLogin()
      .then(onUserLogin);
  }

  @autobind
  processSubscriptionBuy(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onSubscribeClick } = this.props;
    this.props.biEvent('widget.subscription.clicked');
    hideTooltip();
    onSubscribeClick(event);
  }

  @autobind
  processSubscriptionCancel() {
    const { onSubscriptionCancelClick } = this.props;
    hideTooltip();
    onSubscriptionCancelClick();
  }

  get channelSubscription() {
    const { channelData } = this.props;
    let { dealInfo } = channelData;
    dealInfo = dealInfoHelpers.getSubscriptionPriceInfo(dealInfo);

    if (!dealInfo) {
      return null;
    }

    return (
      <ChannelSubscription styleName="channel-subscription"
                           channelData={channelData}
                           onSubscribeClick={this.processSubscriptionBuy}
                           onSubscriptionCancelClick={this.processSubscriptionCancel} />
    );
  }

  @autobind
  logOut() {
    const { onUserLogout } = this.props;
    onUserLogout();
    WixSDK.logOutCurrentMember();
  }

  render() {
    const { className, currentSiteUser, appSettings, popoutSide } = this.props;

    if (!isSignInVisible(appSettings)) {
      return null;
    }

    if (!currentSiteUser) {
      return (
        <LinkButton className={`qa-sign-in ${className}`}
                    styleName="account-button"
                    onClick={this.showLoginForm}>
          <FormattedMessage {...translations.signIn} />
        </LinkButton>
      );
    }

    return (
      <div className={`qa-account ${className}`}
           styleName="account-preview-button-wrapper">
        <Tooltip preventHideOnHover
                 popoutSide={popoutSide}
                 iconName="avatar"
                 styleName="account-preview-button"
                 popoutClassName={styles.popout}
                 popoutInnerClassName={styles['popout-inner']}
                 popoutTriangleClassName={styles['popout-triangle']}>
          <div styleName="user-email"
               className="qa-account-button-user-email">
            {currentSiteUser.email}
          </div>

          {this.channelSubscription}

          <div styleName="logout-wrapper">
            <LinkButton styleName="logout"
                        className="qa-account-button-user-logout"
                        onClick={this.logOut}>
              <FormattedMessage {...translations.logout} />
            </LinkButton>
          </div>
        </Tooltip>
      </div>
    );

  }
}

@connect(state => ({
  appSettings: getAllSettings(state),
  currentSiteUser: getCurrentSiteUser(state),
}))
@VODBiEvents()
@VODCSSModules(styles)
export default class AccountButton extends BaseAccountButton {
  static displayName = 'AccountButton';
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button.js